import { Users, Camera, Video, QrCode } from "lucide-react";

export default function EventGalleryScreen({
  title = "Sarah & David",
  date = "12.06.2026",
  photos = 342,
  videos = 58,
  contributors = 87,
  image,
}) {
  return (
    <div className="flex h-full flex-col bg-neutral-950 text-white">
      <div
        className="relative h-40 w-full"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/40 to-transparent" />
        <div className="absolute bottom-3 left-4 right-4">
          <p className="font-['Playfair_Display'] text-xl leading-tight">{title}</p>
          <p className="mt-0.5 text-[10px] uppercase tracking-[0.2em] text-neutral-300">{date}</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 px-4 py-3">
        <Stat icon={<Camera className="h-3 w-3" strokeWidth={1.5} />} label="Photos" value={photos} />
        <Stat icon={<Video className="h-3 w-3" strokeWidth={1.5} />} label="Videos" value={videos} />
        <Stat icon={<Users className="h-3 w-3" strokeWidth={1.5} />} label="Guests" value={contributors} />
      </div>

      <div className="grid grid-cols-3 gap-1 px-2">
        {[...Array(9)].map((_, i) => (
          <div
            key={i}
            className="aspect-square rounded-sm"
            style={{
              backgroundImage: `url(${image}&sig=${i})`,
              backgroundSize: "cover",
              backgroundPosition: `${(i * 15) % 100}% ${(i * 20) % 100}%`,
              filter: i % 3 === 0 ? "grayscale(0.2)" : "none",
            }}
          />
        ))}
      </div>

      <div className="mt-auto flex items-center justify-between border-t border-white/10 px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="grid h-6 w-6 place-items-center rounded-md bg-white/10">
            <QrCode className="h-3 w-3" strokeWidth={1.5} />
          </div>
          <p className="text-[10px] uppercase tracking-[0.15em] text-neutral-300">Event QR</p>
        </div>
        <p className="text-[10px] text-neutral-500">memoire.co</p>
      </div>
    </div>
  );
}

function Stat({ icon, label, value }) {
  return (
    <div className="rounded-lg bg-white/5 px-2 py-1.5">
      <div className="flex items-center gap-1 text-neutral-400">
        {icon}
        <span className="text-[9px] uppercase tracking-wider">{label}</span>
      </div>
      <p className="mt-0.5 text-sm font-medium text-white">{value}</p>
    </div>
  );
}
